export default {
      id: "sli-shevron-left-usage",
      viewBox: "0 0 24 24",
      url: __webpack_public_path__ + "img/icons.25bf3227.svg#sli-shevron-left",
      toString: function () {
        return this.url;
      }
    }